import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

const getSymbols = "/api/business/receipt/receipt-symbols";
const receiptnumber = "/api/business/receipt/receipt-numbers";
const getListReceipt = "/api/business/receipts";
// const getDetail = '/api/business/receipt/{receipt_id}/detail'
const getPaymentType = "/api/business/receipt/payment-types";
const getFeetype = "/api/business/receipt/fee_types";
const licsOfdecisions = "/api/business/receipt/lics-or-decisions";
const getHistory = "/api/business/receipts/histories";
const exportExcel = "/api/business/receipts/excel";
const CreateReceipt = "/api/business/receipt/create";
const updateReceipt = "/api/business/receipt/update";
const getFee = "/api/business/receipt/fee";
const deleteReceipt = "/api/business/receipt/cancel";
const historyDetail = "/api/business/receipts/history/";
const getLicOfDeci = "/api/business/o-t-f-mgm";
const getIncome_fee = "/api/business/f-mgm";
const AddFeeTracking = "/api/business/decision-searchs";
// const getAllotments = '/api/business/receipts/{receipt_id}/allotments'
export default class ReceiptBCDTService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllCompanies(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/companyList")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getSymbols(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(getSymbols)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getReceiptnumbers(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(receiptnumber)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getReceiptnumbers2(type): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(receiptnumber + "?type=" + type)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getSearchReceipt(querySearch: any, cancelToken, page: any, size: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(getListReceipt + "?page=" + page + "&size=" + size, querySearch, { cancelToken: cancelToken.token })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getDetailReceipt(receipt_id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/receipts/${receipt_id}/detail`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getPaymentTypes(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(getPaymentType)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getFeeType(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(getFeetype)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getFeeTypeReceipt(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/receipt/fee_types_receipt")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllserviceSearch() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/telcoService/businessSearch")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public LicsOfdecisions() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(licsOfdecisions)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getHistory(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(getHistory + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(querySearch))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public ExportExcel(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(exportExcel, querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getAllotments(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/receipts/${querySearch}/allotments`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public deleteReceit(querySearch?: any) {
    let obj = {
      reason: querySearch.reason,
    };
    return new Promise<any>((resolve, reject) => {
      axios
        .post(deleteReceipt + `?receipt_id=${querySearch.receipt_id}`, obj)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  /// thêm mới biên lai
  public getListBenefit_comp(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/companies-benefit")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getFeetypes(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/receipt/fee_types`, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getNetworkType(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/receipt/network`, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getLicOfDeci(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(getLicOfDeci, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getLicCpnCom(params?: any) {
    let url = "/api/business/v2/company/lic-numbers?company_id=" + params.comp_id;
    return new Promise<any>((resolve, reject) => {
      axios
        .get(url)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getLicsOfdecisions(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/receipt/lic-decision-number", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public SearchSeaCables(querySearch?: any): Promise<any> {
    let url = "/api/business/sea-cables/doc-repairs";
    return new Promise<any>((resolve, reject) => {
      axios
        .post(url, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public getIncome_fee(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(getIncome_fee, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public Searchccdv(querySearch: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/ccdv-fee-management/ccdv-fee", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }

  public Searchtlm(querySearch: any): Promise<any> {
    let url = "/api/business/track-debt/tlm";
    return new Promise<any>((resolve, reject) => {
      axios
        .post(url, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
  public getFee(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(getFee, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public CreateReceipt(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(CreateReceipt, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public UpdateReceipt(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(updateReceipt, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //view  bien lai
  public getHistoryDetail(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/receipts/${querySearch.receiptId}/history/${querySearch.receipt_his_id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //add kho so
  public AddFeeTracking(querySearch?: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(AddFeeTracking + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(querySearch))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //Lệ phí phân bổ mã
  public SearchOneTime(querySearch?: any): Promise<any> {
    console.log(querySearch);
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/decision-history", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
  // cáp biển
  public getFeeSeaCable(querySearch?: any): Promise<any> {
    console.log(querySearch);
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/receipt/fee/sea-cable" + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(querySearch))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
}
